import React from 'react';

const Seller = ({endDate, buyerMessage, openPopup, isMobile}) => (
    <div className="content seller-view">
        <h3 className="title">{i18n.t('out_of_office.banner.seller.you_are_out')}</h3>
        {!!endDate && <p className="notice">
            {i18n.t('out_of_office.banner.seller.your_gigs')} <strong>{endDate}</strong>
            {!isMobile && <a className="popup-link" onClick={(e) => openPopup(e, 'seller_page')}>
                <i className="fa fa-pencil" aria-hidden="true"></i> {i18n.t('out_of_office.general.edit')}
            </a>}
        </p>}
        { buyerMessage && <p className="buyer-message">{buyerMessage}</p> }
    </div>
);

export default Seller;


// WEBPACK FOOTER //
// ./src/ProfileBanner/Seller.js